import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_PERMISSIONS, UPDATE_PERMISSIONS_SUCCESS, UPDATE_PERMISSIONS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updatePermissions({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/user-permissions`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_PERMISSIONS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_PERMISSIONS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_PERMISSIONS_ERROR, payload: error });
  }
}

export function* watchUpdatePermissions() {
  yield takeEvery(UPDATE_PERMISSIONS, updatePermissions);
}

function* updatePermissionsSaga() {
  yield all([fork(watchUpdatePermissions)]);
}

export default updatePermissionsSaga;
